import { request } from './http';

export async function getDashboardAvailability() {
    return request('/dashboard/availability');
  }

export async function getProjectTypes() {
    return request('/project-types');
  }

export async function createProjectType(projectTypeData) {
    return request('/project-types', {
      method: 'POST',
      body: JSON.stringify(projectTypeData)
    });
  }

export async function updateProjectType(id, projectTypeData) {
    return request(`/project-types/${id}`, {
      method: 'PUT',
      body: JSON.stringify(projectTypeData)
    });
  }

export async function deleteProjectType(id) {
    return request(`/project-types/${id}`, {
      method: 'DELETE'
    });
  }

export async function getPermitAgencies() {
    return request('/permit-agencies');
  }

export async function createPermitAgency(agencyData) {
    return request('/permit-agencies', {
      method: 'POST',
      body: JSON.stringify(agencyData)
    });
  }

export async function updatePermitAgency(id, agencyData) {
    return request(`/permit-agencies/${id}`, {
      method: 'PUT',
      body: JSON.stringify(agencyData)
    });
  }

export async function deletePermitAgency(id) {
    return request(`/permit-agencies/${id}`, {
      method: 'DELETE'
    });
  }

export async function getProjectPermitTypes() {
    return request('/project-permit-types');
  }

export async function createProjectPermitType(permitTypeData) {
    return request('/project-permit-types', {
      method: 'POST',
      body: JSON.stringify(permitTypeData)
    });
  }

export async function updateProjectPermitType(id, permitTypeData) {
    return request(`/project-permit-types/${id}`, {
      method: 'PUT',
      body: JSON.stringify(permitTypeData)
    });
  }

export async function deleteProjectPermitType(id) {
    return request(`/project-permit-types/${id}`, {
      method: 'DELETE'
    });
  }

export async function getProjectElements() {
    return request('/project-elements');
  }

export async function createProjectElement(elementData) {
    return request('/project-elements', {
      method: 'POST',
      body: JSON.stringify(elementData)
    });
  }

export async function updateProjectElement(id, elementData) {
    return request(`/project-elements/${id}`, {
      method: 'PUT',
      body: JSON.stringify(elementData)
    });
  }

export async function deleteProjectElement(id) {
    return request(`/project-elements/${id}`, {
      method: 'DELETE'
    });
  }

export async function getDashboardDataWithCustomer(email, customerId, filters = {}, page = 1, pageSize = 1000) {
    return request('/dashboard/data', {
      method: 'POST',
      body: JSON.stringify({ email, customerId, filters, page, pageSize }),
    });
  }

export async function getComplianceSummaryReportData(companyId, filters = {}, page = 1, pageSize = 50000) {
    return request('/dashboard/compliance-summary-data', {
      method: 'POST',
      body: JSON.stringify({ companyId, filters, page, pageSize })
    });
  }

export async function getDashboardRaciData(customerId) {
    return request('/dashboard/raci-data', {
      method: 'POST',
      body: JSON.stringify({ customerId })
    });
  }

export async function getFilterOptions(customerId) {
    return request('/dashboard/filter-options', {
      method: 'POST',
      body: JSON.stringify({ customerId })
    });
  }

export async function clearDashboardCache(customerId = null) {
    return request('/dashboard/clear-cache', {
      method: 'POST',
      body: JSON.stringify({ customerId })
    });
  }

export async function getCacheStats() {
    return request('/dashboard/cache-stats');
  }

export const dashboardApi = {
  getDashboardAvailability,
  getProjectTypes,
  createProjectType,
  updateProjectType,
  deleteProjectType,
  getPermitAgencies,
  createPermitAgency,
  updatePermitAgency,
  deletePermitAgency,
  getProjectPermitTypes,
  createProjectPermitType,
  updateProjectPermitType,
  deleteProjectPermitType,
  getProjectElements,
  createProjectElement,
  updateProjectElement,
  deleteProjectElement,
  getDashboardDataWithCustomer,
  getComplianceSummaryReportData,
  getDashboardRaciData,
  getFilterOptions,
  clearDashboardCache,
  getCacheStats,
};

